module.exports = __webpack_public_path__ + "static/media/icon_haftungsdach.45d3ec27.svg";